import React from "react";
import { BookOpen, FlaskConical, Newspaper, GraduationCap, FileText, LayoutGrid } from "lucide-react";

export const FILE_TYPE_META = {
    edc_guidelines: { label: "EDC Guidelines", icon: LayoutGrid, tone: "border-violet-400/40 text-violet-300 bg-violet-400/10" },
    manual: { label: "Manual", icon: BookOpen, tone: "border-sky-400/40 text-sky-300 bg-sky-400/10" },
    investigator_brochure: { label: "Investigator Brochure", icon: FlaskConical, tone: "border-emerald-400/40 text-emerald-300 bg-emerald-400/10" },
    newsletter: { label: "Newsletter", icon: Newspaper, tone: "border-amber-400/40 text-amber-300 bg-amber-400/10" },
    training: { label: "Training", icon: GraduationCap, tone: "border-teal-400/40 text-teal-300 bg-teal-400/10" },
    other: { label: "Other", icon: FileText, tone: "border-white/20 text-white/70 bg-white/5" },
};

export function typeMeta(id) {
    return FILE_TYPE_META[id] || { label: id || "—", icon: FileText, tone: "border-white/20 text-white/70 bg-white/5" };
}

/** Chip naming the file type (EDC Guidelines, Manual, …). */
export default function FileTypeBadge({ type, size = "xs", testId }) {
    const m = typeMeta(type);
    const Icon = m.icon;
    const cls = size === "sm" ? "text-[11px] px-2 py-0.5 gap-1.5" : "text-[10px] px-1.5 py-0.5 gap-1";
    return (
        <span className={`inline-flex items-center rounded-full border ${cls} ${m.tone}`} data-testid={testId || `file-type-badge-${type}`}>
            <Icon className="w-3 h-3" strokeWidth={1.75} />
            {m.label}
        </span>
    );
}
